import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import LocationFormCard from './LocationFormCard';
import LocationDropDown from './LocationDropDown';
import { fetchCities } from '../../../actions/listing';
import { locations } from '../../../lib/constants';

import style from '../../../styles/sass/components/LocationForm.module.scss';

interface Props {
  cities: any[];
  children?: any;
  classes: any;
  disabled?: boolean;
  dispatch: any;
  hideCityField?: boolean;
  initialCity?: string;
  initialState?: string;
  locationsOverride?: any;
  onSubmit: Function;
  showCard?: boolean;
  toolsHeadline?: string;
  toolTipText?: string;
}
interface State {
  selectedLocation: string | undefined;
  selectedCity: string | undefined;
}

const styles = {
  dropDownWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
};

export class LocationForm extends React.Component<Props, State> {
  state = {
    selectedLocation: this.props.initialState || undefined,
    selectedCity: undefined,
  };

  componentDidMount() {
    if (this.props.initialState) {
      this.setLocation(this.props.initialState, false);
    }
  }

  setLocation = (selectedLocation: any, submitForm: boolean) => {
    if (!this.props.hideCityField) {
      this.props.dispatch(fetchCities(selectedLocation));
    }
    if (selectedLocation !== this.state.selectedLocation) {
      this.setState({ selectedLocation, selectedCity: undefined }, () => {
        if (submitForm) {
          this.handleFormSubmit();
        }
      });
    } else {
      this.setState(
        { selectedLocation, selectedCity: this.props.initialCity },
        () => {
          if (submitForm) {
            this.handleFormSubmit();
          }
        },
      );
    }
  };

  setCity = (selectedCity: string, submitForm: boolean) => {
    this.setState({ selectedCity }, () => {
      if (submitForm) {
        this.handleFormSubmit();
      }
    });
  };

  handleFormSubmit = () => {
    this.props.onSubmit(this.state.selectedLocation, this.state.selectedCity);
  };

  render() {
    const {
      cities,
      disabled,
      hideCityField,
      locationsOverride,
      onSubmit,
      showCard,
      classes,
    } = this.props;
    const locationsToUse = locationsOverride ? locationsOverride : locations;
    return (
      <div className={`${style.locationForm} location-form`}>
        {showCard ? (
          <LocationFormCard
            cities={cities}
            disabled={disabled}
            hideCityField={hideCityField}
            locations={locationsToUse}
            onSubmit={this.handleFormSubmit}
            selectedCity={this.state.selectedCity}
            selectedLocation={this.state.selectedLocation}
            setCity={(city: string) => this.setCity(city, false)}
            setLocation={(location: string) =>
              this.setLocation(location, false)
            }
            toolTipText={this.props.toolTipText}
            toolsHeadline={
              this.props.toolsHeadline ||
              `Set the location that you're interested in`
            }
          >
            {this.props.children}
          </LocationFormCard>
        ) : (
          <div className={classes.dropDownWrapper}>
            <LocationDropDown
              cities={cities}
              disabled={disabled}
              hideCityField={hideCityField}
              locations={locationsToUse}
              selectedCity={this.state.selectedCity}
              selectedLocation={this.state.selectedLocation}
              setCity={(city: string) => this.setCity(city, true)}
              setLocation={(location: string) =>
                this.setLocation(location, true)
              }
            >
              {this.props.children}
            </LocationDropDown>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  cities: state.listings.cities,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(LocationForm));
